export const SHOW_LOADER = "SHOW_LOADER";

//AUTHENTICATION
export const AUTHENTICATION_OPEN_LOGIN_DIALOG          = "AUTHENTICATION_OPEN_LOGIN_DIALOG";
export const AUTHENTICATION_CLOSE_LOGIN_DIALOG         = "AUTHENTICATION_CLOSE_LOGIN_DIALOG";
export const AUTHENTICATION_LOGIN_REQUEST              = "AUTHENTICATION_LOGIN_REQUEST";
export const AUTHENTICATION_LOGIN_SUCCESS              = "AUTHENTICATION_LOGIN_SUCCESS";
export const AUTHENTICATION_LOGIN_ERROR                = "AUTHENTICATION_LOGIN_ERROR";
export const AUTHENTICATION_LOGOUT_REQUEST             = "AUTHENTICATION_LOGOUT_REQUEST";
export const AUTHENTICATION_LOGOUT_SUCCESS             = "AUTHENTICATION_LOGOUT_SUCCESS";
export const AUTHENTICATION_LOGOUT_ERROR               = "AUTHENTICATION_LOGOUT_ERROR";

//REQUEST TO SERVER HOLDING
export const SERVICE_HOLDING_LIST_REQUEST              = "SERVICE_HOLDING_LIST_REQUEST";
export const SERVICE_HOLDING_LIST_SUCCESS              = "SERVICE_HOLDING_LIST_SUCCESS";
export const SERVICE_HOLDING_LIST_ERROR                = "SERVICE_HOLDING_LIST_ERROR";
export const SERVICE_HOLDING_SET_REQUEST               = "SERVICE_HOLDING_SET_REQUEST";
export const SERVICE_HOLDING_SET_SUCCESS               = "SERVICE_HOLDING_SET_SUCCESS";
export const SERVICE_HOLDING_SET_ERROR                 = "SERVICE_HOLDING_SET_ERROR";
export const SERVICE_HOLDING_REFRESH_LIST              = "SERVICE_HOLDING_REFRESH_LIST";

//REQUEST TO SERVER LIBRA
export const SERVICE_LIBRA_LIST_REQUEST                = "SERVICE_LIBRA_LIST_REQUEST";
export const SERVICE_LIBRA_LIST_SUCCESS                = "SERVICE_LIBRA_LIST_SUCCESS";
export const SERVICE_LIBRA_LIST_ERROR                  = "SERVICE_LIBRA_LIST_ERROR";
export const SERVICE_LIBRA_SET_REQUEST                 = "SERVICE_LIBRA_SET_REQUEST";
export const SERVICE_LIBRA_SET_SUCCESS                 = "SERVICE_LIBRA_SET_SUCCESS";
export const SERVICE_LIBRA_SET_ERROR                   = "SERVICE_LIBRA_SET_ERROR";
export const SERVICE_LIBRA_REFRESH_LIST                = "SERVICE_LIBRA_REFRESH_LIST";
    //Tipologie
export const SERVICE_LIBRA_TIPOLOGIE_LIST_REQUEST      = "SERVICE_LIBRA_TIPOLOGIE_LIST_REQUEST";
export const SERVICE_LIBRA_TIPOLOGIE_LIST_SUCCESS      = "SERVICE_LIBRA_TIPOLOGIE_LIST_SUCCESS";
export const SERVICE_LIBRA_TIPOLOGIE_LIST_ERROR        = "SERVICE_LIBRA_TIPOLOGIE_LIST_ERROR";
    //Modelli
export const SERVICE_LIBRA_MODELLO_LIST_REQUEST        = "SERVICE_LIBRA_MODELLO_LIST_REQUEST";
export const SERVICE_LIBRA_MODELLO_LIST_SUCCESS        = "SERVICE_LIBRA_MODELLO_LIST_SUCCESS";
export const SERVICE_LIBRA_MODELLO_LIST_ERROR          = "SERVICE_LIBRA_MODELLO_LIST_ERROR";

//REQUEST TO SERVER PESATE
export const SERVICE_PESATE_LIST_REQUEST               = "SERVICE_PESATE_LIST_REQUEST";
export const SERVICE_PESATE_LIST_SUCCESS               = "SERVICE_PESATE_LIST_SUCCESS";
export const SERVICE_PESATE_LIST_ERROR                 = "SERVICE_PESATE_LIST_ERROR";
export const SERVICE_PESATE_DETAILS_REQUEST            = "SERVICE_PESATE_DETAILS_REQUEST";
export const SERVICE_PESATE_DETAILS_SUCCESS            = "SERVICE_PESATE_DETAILS_SUCCESS";
export const SERVICE_PESATE_DETAILS_ERROR              = "SERVICE_PESATE_DETAILS_ERROR";
export const SERVICE_PESATE_DETAILS_CLOSE              = "SERVICE_PESATE_DETAILS_CLOSE";
export const SERVICE_PESATE_REFRESH_LIST               = "SERVICE_PESATE_REFRESH_LIST";
export const SERVICE_PESATE_DIALOG_FILTRI_OPEN         = "SERVICE_PESATE_DIALOG_FILTRI_OPEN" ;
export const SERVICE_PESATE_SET_FILTER                 = "SERVICE_PESATE_SET_FILTER";
export const SERVICE_PESATE_SET_FILTER_REQUEST         = "SERVICE_PESATE_SET_FILTER_REQUEST";
export const SERVICE_PESATE_SET_FILTER_SUCCESS         = "SERVICE_PESATE_SET_FILTER_SUCCESS";
export const SERVICE_PESATE_SET_FILTER_ERROR           = "SERVICE_PESATE_SET_FILTER_ERROR";
export const SERVICE_PESATE_GET_FILTER_REQUEST         = "SERVICE_PESATE_GET_FILTER_REQUEST";
export const SERVICE_PESATE_GET_FILTER_SUCCESS         = "SERVICE_PESATE_GET_FILTER_SUCCESS";
export const SERVICE_PESATE_GET_FILTER_ERROR           = "SERVICE_PESATE_GET_FILTER_ERROR";
export const SERVICE_PESATE_DIALOG_FILTRI_CLOSE        = "SERVICE_DIALOG_FILTRI_CLOSE";
export const SERVICE_PESATA_ADD_FILTER                 = "SERVICE_PESATA_ADD_FILTER";
export const SERVICE_PESATA_REMOVE_FILTER              = "SERVICE_PESATA_REMOVE_FILTER";
export const SERVICE_PESATE_FILE_TYPE_LIST_REQUEST     = "SERVICE_PESATE_FILE_TYPE_LIST_REQUEST";
export const SERVICE_PESATE_FILE_TYPE_LIST_SUCCESS     = "SERVICE_PESATE_FILE_TYPE_LIST_SUCCESS";
export const SERVICE_PESATE_FILE_TYPE_LIST_ERROR       = "SERVICE_PESATE_FILE_TYPE_LIST_ERROR";
export const SERVICE_PESATE_FILE_TYPE_LIST_CLOSE       = "SERVICE_PESATE_FILE_TYPE_LIST_CLOSE";
export const SERVICE_PESATE_FILE_DOWNLOAD_REQUEST      = "SERVICE_PESATE_FILE_DOWNLOAD_REQUEST";
export const SERVICE_PESATE_FILE_DOWNLOAD_SUCCESS      = "SERVICE_PESATE_FILE_DOWNLOAD_SUCCESS";
export const SERVICE_PESATE_FILE_DOWNLOAD_ERROR        = "SERVICE_PESATE_FILE_DOWNLOAD_ERROR";

//REQUEST TO SERVER STAMPANTE
export const SERVICE_STAMPANTE_LIST_REQUEST            = "SERVICE_STAMPANTE_LIST_REQUEST";
export const SERVICE_STAMPANTE_LIST_SUCCESS            = "SERVICE_STAMPANTE_LIST_SUCCESS";
export const SERVICE_STAMPANTE_LIST_ERROR              = "SERVICE_STAMPANTE_LIST_ERROR";
export const SERVICE_STAMPANTE_MODELLO_LIST_REQUEST    = "SERVICE_STAMPANTE_MODELLO_LIST_REQUEST";
export const SERVICE_STAMPANTE_MODELLO_LIST_SUCCESS    = "SERVICE_STAMPANTE_MODELLO_LIST_SUCCESS";
export const SERVICE_STAMPANTE_MODELLO_LIST_ERROR      = "SERVICE_STAMPANTE_MODELLO_LIST_ERROR";
export const SERVICE_STAMPANTE_MARCA_LIST_REQUEST      = "SERVICE_STAMPANTE_MARCA_LIST_REQUEST";
export const SERVICE_STAMPANTE_MARCA_LIST_SUCCESS      = "SERVICE_STAMPANTE_MARCA_LIST_SUCCESS";
export const SERVICE_STAMPANTE_MARCA_LIST_ERROR        = "SERVICE_STAMPANTE_MARCA_LIST_ERROR";
export const SERVICE_STAMPANTE_REFRESH_LIST            = "SERVICE_STAMPANTE_REFRESH_LIST";
export const SERVICE_STAMPANTE_SET_REQUEST             = "SERVICE_STAMPANTE_SET_REQUEST";
export const SERVICE_STAMPANTE_SET_SUCCESS             = "SERVICE_STAMPANTE_SET_SUCCESS";
export const SERVICE_STAMPANTE_SET_ERROR               = "SERVICE_STAMPANTE_SET_ERROR";

//REQUEST TO SERVER AZIENDE
export const SERVICE_AZIENDE_LIST_REQUEST              = "SERVICE_AZIENDE_LIST_REQUEST";
export const SERVICE_AZIENDE_LIST_SUCCESS              = "SERVICE_AZIENDE_LIST_SUCCESS";
export const SERVICE_AZIENDE_LIST_ERROR                = "SERVICE_AZIENDE_LIST_ERROR";
export const SERVICE_AZIENDE_REFRESH_LIST              = "SERVICE_AZIENDE_REFRESH_LIST";
export const SERVICE_AZIENDE_SET_REQUEST               = "SERVICE_AZIENDE_SET_REQUEST";
export const SERVICE_AZIENDE_SET_SUCCESS               = "SERVICE_AZIENDE_SET_SUCCESS";
export const SERVICE_AZIENDE_SET_ERROR                 = "SERVICE_AZIENDE_SET_ERROR";
export const SERVICE_AZIENDE_TUPLA_LIST_REQUEST        = "SERVICE_AZIENDE_TUPLA_LIST_REQUEST";
export const SERVICE_AZIENDE_TUPLA_LIST_SUCCESS        = "SERVICE_AZIENDE_TUPLA_LIST_SUCCESS";
export const SERVICE_AZIENDE_TUPLA_LIST_ERROR          = "SERVICE_AZIENDE_TUPLA_LIST_ERROR";

//REQUEST TO SERVER HOME
export const SERVICE_USERINFO_REQUEST             = "SERVICE_USERINFO_REQUEST";
export const SERVICE_USERINFO_SUCCESS             = "SERVICE_USERINFO_SUCCESS";
export const SERVICE_USERINFO_ERROR               = "SERVICE_USERINFO_ERROR";

//REQUEST TO SERVER IMPIANTI
export const SERVICE_IMPIANTI_LIST_REQUEST             = "SERVICE_IMPIANTI_LIST_REQUEST";
export const SERVICE_IMPIANTI_LIST_SUCCESS             = "SERVICE_IMPIANTI_LIST_SUCCESS";
export const SERVICE_IMPIANTI_LIST_ERROR               = "SERVICE_IMPIANTI_LIST_ERROR";
export const SERVICE_IMPIANTI_SET_REQUEST              = "SERVICE_IMPIANTI_SET_REQUEST";
export const SERVICE_IMPIANTI_SET_SUCCESS              = "SERVICE_IMPIANTI_SET_SUCCESS";
export const SERVICE_IMPIANTI_SET_ERROR                = "SERVICE_IMPIANTI_SET_ERROR";
export const SERVICE_IMPIANTI_REFRESH_LIST             = "SERVICE_IMPIANTI_REFRESH_LIST";
export const SERVICE_IMPIANTI_TUPLA_LIST_REQUEST       = "SERVICE_IMPIANTI_TUPLA_LIST_REQUEST";
export const SERVICE_IMPIANTI_TUPLA_LIST_SUCCESS       = "SERVICE_IMPIANTI_TUPLA_LIST_SUCCESS";
export const SERVICE_IMPIANTI_TUPLA_LIST_ERROR         = "SERVICE_IMPIANTI_TUPLA_LIST_ERROR";

//REQUEST TO SERVER OPERATORI
export const SERVICE_OPERATORI_LIST_REQUEST            = "SERVICE_OPERATORI_LIST_REQUEST";
export const SERVICE_OPERATORI_LIST_SUCCESS            = "SERVICE_OPERATORI_LIST_SUCCESS";
export const SERVICE_OPERATORI_LIST_ERROR              = "SERVICE_OPERATORI_LIST_ERROR";
export const SERVICE_OPERATORI_REFRESH_LIST            = "SERVICE_OPERATORI_REFRESH_LIST";
export const SERVICE_OPERATORI_OPEN_ADD_DIALOG         = "SERVICE_OPERATORI_OPEN_ADD_DIALOG";
export const SERVICE_OPERATORI_CLOSE_ADD_DIALOG        = "SERVICE_OPERATORI_CLOSE_ADD_DIALOG";
export const SERVICE_OPERATORI_ADD_REQUEST             = "SERVICE_OPERATORI_ADD_REQUEST";
export const SERVICE_OPERATORI_ADD_SUCCESS             = "SERVICE_OPERATORI_ADD_SUCCESS";
export const SERVICE_OPERATORI_ADD_ERROR               = "SERVICE_OPERATORI_ADD_ERROR";

//REQUEST TO SERVER TABELLE
export const SERVICE_TABELLE_LIST_REQUEST              = "SERVICE_TABELLE_LIST_REQUEST";
export const SERVICE_TABELLE_LIST_SUCCESS              = "SERVICE_TABELLE_LIST_SUCCESS";
export const SERVICE_TABELLE_LIST_ERROR                = "SERVICE_TABELLE_LIST_ERROR";
export const SERVICE_TABELLE_REFRESH_LIST              = "SERVICE_TABELLE_REFRESH_LIST";
export const SERVICE_TABELLE_SET_REQUEST               = "SERVICE_TABELLE_SET_REQUEST";
export const SERVICE_TABELLE_SET_SUCCESS               = "SERVICE_TABELLE_SET_SUCCESS";
export const SERVICE_TABELLE_SET_ERROR                 = "SERVICE_TABELLE_SET_ERROR";
export const SERVICE_TABELLE_SET_VALUE_REQUEST         = "SERVICE_TABELLE_SET_VALUE_REQUEST";
export const SERVICE_TABELLE_SET_VALUE_SUCCESS         = "SERVICE_TABELLE_SET_VALUE_SUCCESS";
export const SERVICE_TABELLE_SET_VALUE_ERROR           = "SERVICE_TABELLE_SET_VALUE_ERROR";
export const SERVICE_TABELLE_GET_VALUES_REQUEST        = "SERVICE_TABELLE_GET_VALUES_REQUEST";
export const SERVICE_TABELLE_GET_VALUES_SUCCESS        = "SERVICE_TABELLE_GET_VALUES_SUCCESS";
export const SERVICE_TABELLE_GET_VALUES_ERROR          = "SERVICE_TABELLE_GET_VALUES_ERROR";
export const SERVICE_TABELLE_GET_COLUMN_VALUES_REQUEST = "SERVICE_TABELLE_GET_COLUMN_VALUES_REQUEST";
export const SERVICE_TABELLE_GET_COLUMN_VALUES_SUCCESS = "SERVICE_TABELLE_GET_COLUMN_VALUES_SUCCESS";
export const SERVICE_TABELLE_GET_COLUMN_VALUES_ERROR   = "SERVICE_TABELLE_GET_COLUMN_VALUES_ERROR";
export const SERVICE_TABELLE_CLOSE_FILL_TABLE          = "SERVICE_TABELLE_CLOSE_FILL_TABLE";
export const SERVICE_TABELLE_REFRESH_TABLEVALUE        = "SERVICE_TABELLE_REFRESH_TABLEVALUE";

//REQUEST TO SERVER CAMPIPERSONALIZZATI
export const SERVICE_CAMPIPERSONALIZZATI_LIST_REQUEST  = "SERVICE_CAMPIPERSONALIZZATI_LIST_REQUEST";
export const SERVICE_CAMPIPERSONALIZZATI_LIST_SUCCESS  = "SERVICE_CAMPIPERSONALIZZATI_LIST_SUCCESS";
export const SERVICE_CAMPIPERSONALIZZATI_LIST_ERROR    = "SERVICE_CAMPIPERSONALIZZATI_LIST_ERROR";
export const SERVICE_CAMPITABELLA_LIST_REQUEST         = "SERVICE_CAMPITABELLA_LIST_REQUEST";
export const SERVICE_CAMPITABELLA_LIST_SUCCESS         = "SERVICE_CAMPITABELLA_LIST_SUCCESS";
export const SERVICE_CAMPITABELLA_LIST_ERROR           = "SERVICE_CAMPITABELLA_LIST_ERROR";
export const SERVICE_CAMPIPERSONALIZZATI_REFRESH_LIST  = "SERVICE_CAMPIPERSONALIZZATI_REFRESH_LIST";
export const SERVICE_CAMPIPERSONALIZZATI_SET_REQUEST   = "SERVICE_CAMPIPERSONALIZZATI_SET_REQUEST";
export const SERVICE_CAMPIPERSONALIZZATI_SET_SUCCESS   = "SERVICE_CAMPIPERSONALIZZATI_SET_SUCCESS";
export const SERVICE_CAMPIPERSONALIZZATI_SET_ERROR     = "SERVICE_CAMPIPERSONALIZZATI_SET_ERROR";

//REQUEST TO SERVER CONFERMA EMAIL
export const SERVICE_CONFIRM_EMAIL_REQUEST             = "SERVICE_CONFIRM_EMAIL_REQUEST";
export const SERVICE_CONFIRM_EMAIL_SUCCESS             = "SERVICE_CONFIRM_EMAIL_SUCCESS";
export const SERVICE_CONFIRM_EMAIL_ERROR               = "SERVICE_CONFIRM_EMAIL_ERROR";
export const SERVICE_CONFIRM_EMAIL_GOTOLOGIN           = "SERVICE_CONFIRM_EMAIL_GOTOLOGIN";

//REQUEST TO SERVER RECUPERA CREDENZIALI
export const SERVICE_RECOVER_CREDENTIALS_REQUEST       = "SERVICE_RECOVER_CREDENTIALS_REQUEST";
export const SERVICE_RECOVER_CREDENTIALS_SUCCESS       = "SERVICE_RECOVER_CREDENTIALS_SUCCESS";
export const SERVICE_RECOVER_CREDENTIALS_ERROR         = "SERVICE_RECOVER_CREDENTIALS_ERROR";

//STAMPE
export const SERVICE_STAMPE_LIST_REQUEST               = "SERVICE_STAMPE_LIST_REQUEST";
export const SERVICE_STAMPE_LIST_SUCCESS               = "SERVICE_STAMPE_LIST_SUCCESS";
export const SERVICE_STAMPE_LIST_ERROR                 = "SERVICE_STAMPE_LIST_ERROR";
export const SERVICE_STAMPE_SET_REQUEST                = "SERVICE_STAMPE_SET_REQUEST";
export const SERVICE_STAMPE_SET_SUCCESS                = "SERVICE_STAMPE_SET_SUCCESS";
export const SERVICE_STAMPE_SET_ERROR                  = "SERVICE_STAMPE_SET_ERROR";
    //FAVORITE
export const SERVICE_STAMPE_CHANGE_FAVORITE            = "SERVICE_STAMPE_CHANGE_FAVORITE";
export const SERVICE_STAMPE_CHANGE_PREDEFINITE         = "SERVICE_STAMPE_CHANGE_PREDEFINITE";
export const SERVICE_STAMPE_SET_FAVORITE_REQUEST       = "SERVICE_STAMPE_SET_FAVORITE_REQUEST";
export const SERVICE_STAMPE_SET_FAVORITE_SUCCESS       = "SERVICE_STAMPE_SET_FAVORITE_SUCCESS";
export const SERVICE_STAMPE_SET_FAVORITE_ERROR         = "SERVICE_STAMPE_SET_FAVORITE_ERROR";
export const SERVICE_STAMPE_SET_PREDEFINITE_REQUEST    = "SERVICE_STAMPE_SET_PREDEFINITE_REQUEST";
export const SERVICE_STAMPE_SET_PREDEFINITE_SUCCESS    = "SERVICE_STAMPE_SET_PREDEFINITE_SUCCESS";
export const SERVICE_STAMPE_SET_PREDEFINITE_ERROR      = "SERVICE_STAMPE_SET_PREDEFINITE_ERROR";

//RECUPERA CREDENZIALI
export const SERVICE_RECOVER_VALIDATION_TOKEN_REQUEST  = "SERVICE_RECOVER_VALIDATION_TOKEN_REQUEST";
export const SERVICE_RECOVER_VALIDATION_TOKEN_SUCCESS  = "SERVICE_RECOVER_VALIDATION_TOKEN_SUCCESS";
export const SERVICE_RECOVER_VALIDATION_TOKEN_ERROR    = "SERVICE_RECOVER_VALIDATION_TOKEN_ERROR";
export const SERVICE_RECOVER_SET_PASSWORD_REQUEST      = "SERVICE_RECOVER_SET_PASSWORD_REQUEST";
export const SERVICE_RECOVER_SET_PASSWORD_SUCCESS      = "SERVICE_RECOVER_SET_PASSWORD_SUCCESS";
export const SERVICE_RECOVER_SET_PASSWORD_ERROR        = "SERVICE_RECOVER_SET_PASSWORD_ERROR";

//CHECK VALUE
export const SERVICE_CHECK_USERNAME_REQUEST  = "SERVICE_CHECK_USERNAME_REQUEST";
export const SERVICE_CHECK_USERNAME_SUCCESS  = "SERVICE_CHECK_USERNAME_SUCCESS";
export const SERVICE_CHECK_USERNAME_ERROR    = "SERVICE_CHECK_USERNAME_ERROR";
export const SERVICE_CHECK_EMAIL_REQUEST     = "SERVICE_CHECK_EMAIL_REQUEST";
export const SERVICE_CHECK_EMAIL_SUCCESS     = "SERVICE_CHECK_EMAIL_SUCCESS";
export const SERVICE_CHECK_EMAIL_ERROR       = "SERVICE_CHECK_EMAIL_ERROR";

//PAGAMENTO
export const SERVICE_PAYMENT_CONFIG_REQUEST  = "SERVICE_PAYMENT_CONFIG_REQUEST";
export const SERVICE_PAYMENT_CONFIG_SUCCESS  = "SERVICE_PAYMENT_CONFIG_SUCCESS";
export const SERVICE_PAYMENT_CONFIG_ERROR    = "SERVICE_PAYMENT_CONFIG_ERROR";
export const SERVICE_PAYMENT_PRICES_REQUEST  = "SERVICE_PAYMENT_PRICES_REQUEST";
export const SERVICE_PAYMENT_PRICES_SUCCESS  = "SERVICE_PAYMENT_PRICES_SUCCESS";
export const SERVICE_PAYMENT_PRICES_ERROR    = "SERVICE_PAYMENT_PRICES_ERROR";

//REGISTRAZIONE
export const SERVICE_SIGNIN_CLOUD_REQUEST = "SERVICE_SIGNIN_CLOUD_REQUEST";
export const SERVICE_SIGNIN_CLOUD_SUCCESS = "SERVICE_SIGNIN_CLOUD_SUCCESS";
export const SERVICE_SIGNIN_CLOUD_ERROR = "SERVICE_SIGNIN_CLOUD_ERROR";

//IMPOSTAZIONI
export const SERVICE_CHANGEPASSWORD_REQUEST = "SERVICE_CHANGEPASSWORD_REQUEST";
export const SERVICE_CHANGEPASSWORD_SUCCESS = "SERVICE_CHANGEPASSWORD_SUCCESS";
export const SERVICE_CHANGEPASSWORD_ERROR   = "SERVICE_CHANGEPASSWORD_ERROR";
export const SERVICE_CHANGEPASSWORD_CLOSEDIALOG = "SERVICE_CHANGEPASSWORD_CLOSEDIALOG";
export const SERVICE_CHANGEPASSWORD_OPENDIALOG = "SERVICE_CHANGEPASSWORD_OPENDIALOG";

//LOGICAL OPERATOR
export const SERVICE_FILTER_LOGICAL_OPERATOR_REQUEST = "SERVICE_FILTER_LOGICAL_OPERATOR_REQUEST";
export const SERVICE_FILTER_LOGICAL_OPERATOR_SUCCESS = "SERVICE_FILTER_LOGICAL_OPERATOR_SUCCESS";
export const SERVICE_FILTER_LOGICAL_OPERATOR_ERROR   = "SERVICE_FILTER_LOGICAL_OPERATOR_ERROR";

//LANGUAGE
export const SERVICE_LANGUAGE_SET_REQUEST = "SERVICE_LANGUAGE_SET_REQUEST";
export const SERVICE_LANGUAGE_SET_SUCCESS = "SERVICE_LANGUAGE_SET_SUCCESS";
export const SERVICE_LANGUAGE_SET_ERROR   = "SERVICE_LANGUAGE_SET_ERROR";
export const SERVICE_LANGUAGE_GET_REQUEST = "SERVICE_LANGUAGE_GET_REQUEST";
export const SERVICE_LANGUAGE_GET_SUCCESS = "SERVICE_LANGUAGE_GET_SUCCESS";
export const SERVICE_LANGUAGE_GET_ERROR   = "SERVICE_LANGUAGE_GET_ERROR";



// WEBPACK FOOTER //
// ./src/Actions/Action_Type.js